import CommercialStagingForm from "./CommercialStagingForm"

const VectorDesignForm = () => {
    return (
        <CommercialStagingForm unitPrice={38} />
    )
}

export default VectorDesignForm;